var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 152 152",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 52.1,
    x2: 62.93,
    y1: 48.7,
    y2: 59.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#186eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186eb3",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 57.56,
    x2: 77.07,
    xlinkHref: "#linear-gradient",
    y1: 54.12,
    y2: 73.64
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 89.14,
    x2: 100.14,
    xlinkHref: "#linear-gradient",
    y1: 92.43,
    y2: 103.44
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 73.26,
    x2: 148.1,
    xlinkHref: "#linear-gradient",
    y1: 74.03,
    y2: 148.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_30.Percent",
    "data-name": "30.Percent"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#2196f3",
    height: 152,
    rx: 12,
    width: 152
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.31 60.67a6.46 6.46 0 0 1 -1.55-4.48v-4a6.78 6.78 0 0 1 1.55-4.7 5.32 5.32 0 0 1 4.17-1.73 5.18 5.18 0 0 1 4.22 1.78 6.79 6.79 0 0 1 1.5 4.54v3.18q0 7.13-5.61 7.12a5.44 5.44 0 0 1 -4.28-1.71z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.92 86.8-19-19q4.78 4.37 12.64 4.36t12.59-4.36a15.19 15.19 0 0 0 4.65-11.6v-3.85q0-7.07-4.09-11.38l13.45 13.45z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.69 91.33a6.55 6.55 0 0 1 1.55 4.54l-.06 5.47q-.42 4.88-5.61 4.88a5.44 5.44 0 0 1 -4.17-1.88 6.34 6.34 0 0 1 -1.71-4.34v-4.4a6.46 6.46 0 0 1 1.66-4.38 6 6 0 0 1 8.34.11z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99 48.29-38 60.82-8.39-4.23 47.13 47.12h40.26a12 12 0 0 0 12-12v-38.72zm12.83 51.71q0 7.26-4.65 11.65t-12.61 4.35q-7.86 0-12.64-4.36t-4.78-11.94v-3.85a15.14 15.14 0 0 1 4.73-11.65q4.73-4.38 12.58-4.38t12.67 4.33q4.7 4.34 4.7 12.08z",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "m40.17 52.09a15.28 15.28 0 0 1 4.7-11.65q4.71-4.44 12.61-4.44t12.67 4.41q4.65 4.41 4.65 11.94v3.85a15.19 15.19 0 0 1 -4.65 11.6q-4.65 4.38-12.56 4.38t-12.59-4.36q-4.79-4.35-4.78-11.94zm11.59 4.1a6.46 6.46 0 0 0 1.55 4.48 5.44 5.44 0 0 0 4.28 1.73q5.61 0 5.61-7.12v-3.18a6.79 6.79 0 0 0 -1.5-4.54 5.18 5.18 0 0 0 -4.22-1.78 5.32 5.32 0 0 0 -4.17 1.73 6.78 6.78 0 0 0 -1.55 4.7zm9.24 52.92-8.39-4.23 38-60.81 8.39 4.22zm16.15-13.26a15.14 15.14 0 0 1 4.73-11.65q4.73-4.38 12.58-4.38t12.67 4.33q4.7 4.34 4.7 12.08v3.77q0 7.26-4.65 11.65t-12.61 4.35q-7.86 0-12.64-4.36t-4.78-11.94zm11.54 4.15a6.34 6.34 0 0 0 1.71 4.39 5.44 5.44 0 0 0 4.17 1.88q5.19 0 5.61-4.88l.06-5.47a6.55 6.55 0 0 0 -1.55-4.54 6 6 0 0 0 -8.34-.11 6.46 6.46 0 0 0 -1.66 4.38z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/percentIcon.551750641b26c9454918d689469d5873.svg";
export { ForwardRef as ReactComponent };